import { api } from "./api";

export const getNotifications = async (data = "") => {
  return api.get(`notifications/filter?${data}`);
};

export const getUnreadCount = async (data = "") => {
  return api.get(`notifications/unread-count?${data}`);
};
